<!-- 我们的服务 -->
<template>
  <div id="service">
    <div class="round-title">
      <p>帮助患者-Help Patients</p>
    </div>
    <ul class="round-list">
      <li class="list-item">
        <div class="item-top">
          <p class="item-top-left"></p>
          <p class="item-top-right"></p>
          <p class="iconfont item-icon">&#xe606;</p>
        </div>
        <div :class="language">{{ this.$t("lang.Home.noWait") }}</div>
      </li>
      <li class="list-item">
        <div class="item-top">
          <p class="item-top-left"></p>
          <p class="item-top-right"></p>
          <p class="iconfont item-icon" style="font-size: 70px">&#xe6b1;</p>
        </div>
        <div :class="language">{{ this.$t("lang.Home.noExpensive") }}</div>
      </li>
      <li class="list-item">
        <div class="item-top">
          <p class="item-top-left"></p>
          <p class="item-top-right"></p>
          <p class="iconfont item-icon">&#xe645;</p>
        </div>
        <div :class="language">{{ this.$t("lang.Home.noHard") }}</div>
      </li>
      <li class="list-item" style="margin-right: 0">
        <div class="item-top">
          <p class="item-top-left"></p>
          <p class="item-top-right"></p>
          <p class="iconfont item-icon">&#xe607;</p>
        </div>
        <div :class="language">
          {{ this.$t("lang.Home.betterTreatment") }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HomeCircle",
  data() {
    return {
      itemBottom: "item-bottom-en",
      language: ""
    };
  },
  mounted() {
    this.setStyle();
  },
  beforeUpdate() {
    this.setStyle();
  },
  methods: {
    setStyle() {
      if (this.$i18n.locale === "en-US") {
        this.language = "item-bottom-us";
      } else if (this.$i18n.locale === "zh-CN") {
        this.language = "item-bottom";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#service {
  width: 75%;
  height: 200px;
  margin: 0 auto 20px auto;
  .round-title {
    margin-top: 30px;
    color: #2789ea;
    font-size: 20px;
    font-family: PingFangSC-Regular;
  }
  .round-list {
    margin-top: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    .list-item {
      margin-right: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .item-top {
        height: 100px;
        width: 100px;
        border-radius: 50%;
        position: relative;
        display: flex;
        .item-top-left {
          width: 50%;
          background: #3490ec;
          border-radius: 50px 0 0 50px;
        }
        .item-top-right {
          width: 50px;
          background: #2a76c9;
          border-radius: 0 50px 50px 0;
        }
      }
      .item-bottom {
        margin-top: 20px;
        text-align: center;
        font-size: 24px;
        color: #525252;
      }
      .item-bottom-us {
        margin-top: 20px;
        text-align: center;
        font-size: 12px;
        color: #525252;
      }
    }
  }
}
.item-icon {
  color: #ffffff;
  font-size: 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
